import Logger from '../logger';
import { shouldIgnore } from '../ignore';
import { setConfigOverride } from '../url-config/url-config-override';
import { transformOldOrder } from './order-transform';

const openChat = (args, callbacks) => {
    if (args?.orderDetails) {
        args.orderDetails = transformOldOrder(args.orderDetails);
    }
    if (shouldIgnore(args, callbacks)) {
        Logger.log('openChat -> ignored');
        return null;
    }
    Logger.log('openChat ->', window.WC.chatProvider);
    args = typeof args === 'object' ? args : {};
    switch (window.WC.chatProvider) {
        case 'Closer':
            if (window.WC.Closer) {
                window.WC.Closer.open(args, callbacks);
            } else {
                document.addEventListener('WCCloserLoaded', () => {
                    window.WC.Closer.open(args, callbacks);
                });
            }
            break;
        default:
            window.OPLWCParent?.start(args);
            break;
    }
};

const open = (args) => {
    Logger.log('open ->', JSON.stringify(args));

    setConfigOverride(args);

    if (!window.OPLWCParent) {
        document.addEventListener('WCCParentLoaded', () => {
            window.OPLWCParent.open({ config: { ...args } });
        });
    } else {
        window.OPLWCParent.open({ config: { ...args } });
    }
};

export { openChat, open };
